import React, { useEffect, useState } from "react";
import { Image, Button } from "react-bootstrap";
import { useAppDispatch, useAppSelector, QueryParamKeys, PublicRoutes } from "src/common";
import { accountActions } from "src/store";
import errorImg from "src/assets/images/404-image.svg";

function PageNotFoundComponent(_props: any) {
  const dispatch = useAppDispatch();
  const current_user_id = useAppSelector((state) => state.account.current_account?.user_id);
  const [user_id, setUserId] = useState<string>();

  // Notes: Save current user_id to local state to be able to re-login with it.
  // Logout so the top nav is reset
  useEffect(() => {
    !!current_user_id && setUserId(current_user_id);
    dispatch(accountActions.logout());
  }, []);

  return (
    <div className="mx-auto max-700 mt-5">
      <div className="not-found">
        <Image alt="404 error illustration" className="mb-5" src={errorImg} />
        <h3 className="bold">Oops! We can't find this page.</h3>
        <Button 
        href={`/${PublicRoutes.login_route}${!!user_id ? `?${QueryParamKeys.USER_ID_QUERY_KEY}=${user_id}` : ""}`}
        size="lg">Go Back</Button>
      </div>
    </div>
  );
}

export default React.memo(PageNotFoundComponent);
